import React, { createContext } from 'react';
import { Vehicle } from './types';

interface ITileKitContext {
  vexUrl: string;
  cdnBlobUrl: string;
  cdnUrl: string;
  vehicle?: Vehicle;
}

export const TileKitContext = createContext<ITileKitContext>({
  cdnBlobUrl: '//cdnblob.fastly.carvanatech.com',
  vexUrl: 'https://vexgateway.fastly.carvana.io/',
  cdnUrl: '//assets.fastly.carvana.io'
});

interface TileKitProviderProps {
  vexUrl?: string;
  cdnBlobUrl?: string;
  cdnUrl?: string;
  vehicle?: Vehicle;
}
export const TileKitProvider: React.FC<TileKitProviderProps> = ({
  vexUrl = 'https://vexgateway.fastly.carvana.io/',
  cdnBlobUrl = '//cdnblob.fastly.carvanatech.com',
  cdnUrl = '//assets.fastly.carvana.io',
  children,
  vehicle
}) => {
  const value = { vexUrl, cdnUrl, cdnBlobUrl, vehicle };
  return (
    <TileKitContext.Provider value={value}>{children}</TileKitContext.Provider>
  );
};
